<template>
  <div class="nx-signing-modal-fail">
    <h4>{{$t('SigningFail')}}</h4>

    <h5 class="mt-4">{{$t('CloseAndRetry')}}</h5>

    <b-alert show class="mt-4" variant="danger">
      <template v-if="value === 'IS_SAFARI'">
       <p>
          {{$t('ERR_ESS_SIGN_0007')}}
        </p>
      </template>
      <template v-if="value === 'CLIENT_NOT_INSTALLED'">
       <p>
          {{$t('ERR_ESS_SIGN_0003')}}
          <br/>
          {{$t('ERR_ESS_SIGN_0004')}}
          <a :href="$common.sanitizeHref(windownloadLink)" style="text-decoration: underline;font-weight: bold;">{{$t('here')}}</a>
          <a v-if="$i18n.locale=='en'">.</a>
          <a v-else>。</a>
          <br/>
          {{$t('ERR_ESS_SIGN_0005')}}
          <a :href="$common.sanitizeHref(macdownloadLink)" style="text-decoration: underline;font-weight: bold;">{{$t('here')}}</a>
          <a v-if="$i18n.locale=='en'">.</a>
          <a v-else>。</a>
        </p>
      </template>
      <template v-else-if="value === 'CLIENT_NOT_STARTED'">
        <!-- <p>{{$t('SigningNotStart')}}</p> -->
        <p>
          {{$t('ERR_ESS_SIGN_0003')}}
          <br/>
          {{$t('ERR_ESS_SIGN_0004')}}
          <a :href="$common.sanitizeHref(windownloadLink)" style="text-decoration: underline;font-weight: bold;">{{$t('here')}}</a>
          <a v-if="$i18n.locale=='en'">.</a>
          <a v-else>。</a>
          <br/>
          {{$t('ERR_ESS_SIGN_0005')}}
          <a :href="$common.sanitizeHref(macdownloadLink)" style="text-decoration: underline;font-weight: bold;">{{$t('here')}}</a>
          <a v-if="$i18n.locale=='en'">.</a>
          <a v-else>。</a>
        </p>
      </template>
      <template v-else-if="value === 'CLIENT_NOT_LATEST'">
        <!-- <p>{{$t('SigningNotStart')}}</p> -->
        <p>
          {{$t('ERR_ESS_SIGN_0006')}}
          <br/>
          {{$t('ERR_ESS_SIGN_0004')}}
          <a :href="$common.sanitizeHref(windownloadLink)" style="text-decoration: underline;font-weight: bold;">{{$t('here')}}</a>
          <a v-if="$i18n.locale=='en'">.</a>
          <a v-else>。</a>
          <br/>
          {{$t('ERR_ESS_SIGN_0005')}}
          <a :href="$common.sanitizeHref(macdownloadLink)" style="text-decoration: underline;font-weight: bold;">{{$t('here')}}</a>
          <a v-if="$i18n.locale=='en'">.</a>
          <a v-else>。</a>
        </p>
      </template>
      <template v-else-if="value === 'Input data is not recognized as valid pdf.'">
        <p>{{$t('SelectUnsignedFiles')}}</p>
      </template>
       <template v-else-if="value === 'ERR_ESS_SIGN_0001'">
        <p>{{$t('ERR_ESS_SIGN_0001')}}</p>
      </template>
      <template v-else-if="value === 'Internal Server Error'">
        <p>{{$t('ERR_ESS_SIGN_0002')}}</p>
      </template>
      <template v-else>
        {{ value }}
      </template>
    </b-alert>
  </div>
</template>

<script>
import {EssSignApi} from '@/api';

export default {
  props: {
    value: {}
  },
  data() {
    return {
      windownloadLink: null,
      macdownloadLink: null
    };
  },  
  async created(){
      var data = await EssSignApi.getSigningClientDownloadPath();
      console.log("data",data)
      this.windownloadLink = data.data.SignClientURL[0].eshSignMsi;
      this.macdownloadLink = data.data.SignClientURL[0].eshSignPkg;
  },
  i18n: {
    messages: {
      en: {
        SigningFail: 'Signing failed',
        CloseAndRetry: 'Please close and retry. Here are the error messages',
        SigningNotInstall: 'The signing client is not installed. Please download it',
        here: 'here',
        SigningNotStart: 'The signing client is not started. Please start it',
        SelectUnsignedFiles:'Please select the unsigned files only'
      },
      zh_hk: {
        SigningFail: '簽署失敗',
        CloseAndRetry: '請關閉並重試。以下是錯誤信息',
        SigningNotInstall: '未安裝簽名客戶端。請下載',
        here: '這裡',
        SigningNotStart: '簽名客戶端未啟動。請開始吧',
        SelectUnsignedFiles: '請選擇未簽名的文件'
      },
      zh_cn: {
        SigningFail: '签署失败',
        CloseAndRetry: '请关闭并重试。 以下是错误信息',
        SigningNotInstall: '未安装签名客户端。 请下载',
        here: '这里',
        SigningNotStart: '签名客户端未启动。 请开始吧',
        SelectUnsignedFiles: '请选择未签名的文件'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-fail {
  text-align: center;
}
</style>

<i18n src="@/locales/responseMsg.locale"></i18n>
